class Random {
    constructor(seed) {
        this.seed = seed
    }
    random_dec() {
        this.seed ^= this.seed << 13
        this.seed ^= this.seed >> 17
        this.seed ^= this.seed << 5
        return ((this.seed < 0 ? ~this.seed + 1 : this.seed) % 1000) / 1000
    }
    random_between(a, b) {
        return a + (b - a) * this.random_dec()
    }
    random_int(a, b) {
        return Math.floor(this.random_between(a, b + 1))
    }
    random_choice(x) {
        return x[Math.floor(this.random_between(0, x.length * 0.99))]
    }
}

let transparnecy, th, fast, jitter, h, s, b, l, logoR, noOfCols;

class Ribbon {

    constructor(ypos, x, lenght, thickness, speed, incr, colOffset, sat, bri, alpha) {
        this.ypos = ypos;
        this.lenght = lenght;
        this.thickness = thickness;
        this.speed = speed;
        this.x = x;
        this.t = 0;
        this.increment = incr;
        this.colOffset = colOffset;
        this.sat = sat;
        this.bri = bri;
        this.alpha = alpha;
    }

    update(p5) {
        p5.colorMode(p5.HSB, 360, 100, 100, 100);
        if(logoR < 0.05) {
            p5.stroke((162 + p5.frameCount/7), 100, 100, 20);
        }
        else if (noOfCols > 1) {
            if(noOfCols == 2) noOfCols = 12;
            else if(noOfCols == 3) noOfCols = 6;
            else if(noOfCols == 4) noOfCols = 4;
            else if(noOfCols == 5) noOfCols = 1.5;
            p5.stroke((p5.frameCount/noOfCols + this.colOffset) % 360, this.sat, this.bri, this.alpha);
        }
        else p5.stroke(this.colOffset%360, this.sat, this.bri, this.alpha);

        p5.strokeWeight(this.thickness);

        var y1 = (this.ypos + this.lenght) * p5.noise(this.t + 5);
        var y2 = (this.ypos + this.lenght) * p5.noise(this.t + 5);
        var y3 = this.ypos * p5.noise(this.t + 10);
        var y4 = this.ypos * p5.noise(this.t + 15);

        for(let i = 0; i < 4; i++){
            this.x[i] += this.speed;
        }
        p5.bezier(this.x[0], y1, this.x[1], y2, this.x[2], y3, this.x[3], y4);
        this.t += this.increment;
    }
}

let ribbons = []
let seed = null;
let p5Start = false;
let ribbonCreated = false;

export default function Sketch(p5) {
  
    p5.setup = () => {
        if (p5Start === false) {
            p5.createCanvas(1000, 1000);
            p5.colorMode(p5.HSB, 360, 100, 100, 100);
            p5.noFill();
            p5Start = true;
        }
        console.log("P5 setup done")
    };

    p5.myCustomRedrawAccordingToNewPropsHandler = (props) => {
        if (props.attributes && props.attributes.attributes.hash_id && seed === null) {
            console.log(props.attributes.attributes.hash_id);
            if (p5Start === false) {
                p5.createCanvas(1000, 1000);
                p5.colorMode(p5.HSB, 360, 100, 100, 100);
                p5.noFill();
                console.log("setup done inside redraw");
            }
            seed = props.attributes.attributes.hash_id;
            p5.noiseSeed(seed);
            let R = new Random(seed);
            
            logoR = R.random_between(0, 1);
            let x = [R.random_between(-20, -10), R.random_between(-120, -110), R.random_between(-30, -20), R.random_between(-110, -100)];
            l = p5.int(R.random_between(10 ,50));
            th = p5.int(R.random_between(4, 10));
            fast = R.random_between(0.5, 1.2);
            jitter = R.random_between(0.0063, 0.001);
            h = p5.int(R.random_between(0, 360));
            s = p5.int(R.random_between(80, 100));
            b = p5.int(R.random_between(80, 100));
            transparnecy = p5.int(R.random_between(15, 40));
            ribbons.push(new Ribbon(p5.height, x, l, th, fast, jitter, h, s, b, transparnecy));
            noOfCols = props.attributes.attributes.Number_of_colors;
            let ribbonObj = {};
            ribbonObj.hash_id = seed;
            ribbonObj.Number_of_colors = noOfCols;
            ribbonObj.width = l;
            ribbonObj.stroke_thickness = th;
            ribbonObj.speed = fast;
            ribbonObj.jitter = jitter;
            ribbonObj.hue = h;
            ribbonObj.saturation = s;
            ribbonObj.brightness = b;
            ribbonObj.alpha = transparnecy;
            ribbonCreated = true;
            console.log("Ribbon created")
        }
    };
  
    p5.draw = () => {
        if (p5Start && ribbonCreated) {
            for(let ribbon of ribbons)
                ribbon.update(p5);
        }
    };
}